import { Injectable } from '@angular/core';
import { environment, varEnvironment } from '../../environments/environment';
import { HttpService } from '../services/http.service';
import { Observable } from 'rxjs';
import { SearchLemmas } from '../interfaces/searchlemmas';


import 'rxjs/add/operator/map';
import 'rxjs/operator/delay';
import 'rxjs/operator/mergeMap';
import 'rxjs/operator/switchMap';

const API_URL = '://' + environment.API_IP + ":"+ environment.PORT_MERGE + environment.ENDPOINT_MERGE
const ENDPOINT_CONCEPTS = API_URL + environment.CONCEPTS;
const ENDPOINT_FORMS = API_URL + environment.MERGE_FORMS
const ENDPOINT_TRANSLATES = API_URL + environment.TRANSLATES;
//const ENDPOINT_THES = API_URL + environment.THESAURUS;
const ENDPOINT_SURR = API_URL + environment.SURROUNDINGS;
const TRANSLATE_ARGS = environment.TRANSLATE_ARGS;
//const THESAURUS_ARGS = environment.THESAURUS_ARGS;
const SURROUNDINGS_ARGS = environment.SURROUNDINGS_ARGS;
const REFERENCE_ARGS = environment.REFERENCE_ARGS;
const RECURSE = environment.ALL_RECURSE;
const CASE_INSENSITIVE = environment.CASE_INSENSITIVE;
const DIACRITIC_INSENSITIVE = environment.DIACRITIC_INSENSITIVE;

@Injectable()
export class MergerService  {
  private query: string;
  private SurroundingsURL: string = varEnvironment.schema + ENDPOINT_SURR;
  private ConceptsURL: string = varEnvironment.schema + ENDPOINT_CONCEPTS;
  private FormsURL: string = varEnvironment.schema + ENDPOINT_FORMS;
  private TranslateURL: string = varEnvironment.schema + ENDPOINT_TRANSLATES;
  private TranslateArguments: string = TRANSLATE_ARGS;
  private SurroundingsArguments: string = SURROUNDINGS_ARGS;
  private ReferenceArguments: string = REFERENCE_ARGS;
  private Recurse: string = RECURSE;
  private Case_insensitive: string = CASE_INSENSITIVE;
  private Diacritic_insensitive: string = DIACRITIC_INSENSITIVE;


  queryWord: string;
  
  requestOptions: {} = {withAuth: true};
  
  constructor(
    private http:HttpService,
  ) {
  }

   recognizeForm(lang: string, query: string): Observable<JSON> {
    return this.http.get(this.FormsURL + lang + "/" + encodeURIComponent(query) + "?" + environment.ALL_RECURSE + "&" + environment.CASE_INSENSITIVE + "&" + environment.DIACRITIC_INSENSITIVE, this.requestOptions)
  }

  //Get the concepts: input a source lang and a word to lookup
  getConcepts(sourceLang: string, query: string): Observable<JSON> {
    //console.log(sourceLang)
    return this.http.get(this.ConceptsURL + sourceLang + "/" + encodeURIComponent(query) + "?" + this.Recurse, this.requestOptions )
  }

  //Get the concepts: input is a SearchLemmas interface: array of lemmas and the form of the lookup
  getConceptsPost(sourceLang: string, query:SearchLemmas): Observable<Object>{
    //console.log("QUERY" + JSON.stringify(query))
    return this.http.post(this.ConceptsURL + sourceLang + "?" + this.Recurse, JSON.stringify(query), this.requestOptions)
  }

  //Get all the concept id's: input is a SearchLemmas interface: array of lemmas and the form of the lookup
  getConceptIDsPost(sourceLang: string, query:SearchLemmas): Observable<Object>{
   // console.log("QUERY" + JSON.stringify(query))
    return this.http.post(this.ConceptsURL + sourceLang + "?" + this.Recurse +  "&count=4&" + environment.CASE_INSENSITIVE + "&" + environment.DIACRITIC_INSENSITIVE, JSON.stringify(query), this.requestOptions)
  }



  //make a translation: input is the source and target lang and the lemma
  makeTranslation(sourceLang: string, targetLang: string, lemma: string): Observable<JSON> {
    return this.http.get(this.TranslateURL + sourceLang + "/" + targetLang + "/" + encodeURIComponent(lemma) + "?" + this.TranslateArguments  + "&" + this.Recurse + "&" + this.ReferenceArguments, this.requestOptions)
  }

  //make (1 or multiple) translation
  makeTranslationsGET(sourceLang: string, targetLang: string, lemmas: string[]): Observable<JSON> {
    let joinedLemmas: string = lemmas.join("##")
    return this.http.get(this.TranslateURL + sourceLang + "/" + targetLang + "/" + encodeURIComponent(joinedLemmas) + "?" + this.TranslateArguments + "&" + this.Recurse + "&" + this.ReferenceArguments, this.requestOptions)
  }

  //make (1 or multiple) translation
  public makeTranslationsPOST(sourceLang: string, targetLang: string, lemmas: SearchLemmas, caseSensitive: boolean, diacriticsSensitive: boolean): Observable<Object> {
    var args: string = "";
    if (!caseSensitive) {
      args += "&" + this.Case_insensitive;
    }
    if (!diacriticsSensitive) {
      args += "&" + this.Diacritic_insensitive
    }
    return this.http.post(this.TranslateURL + sourceLang + "/" + targetLang + "?" + this.TranslateArguments + "&" + this.Recurse + "&" + this.ReferenceArguments + args, JSON.stringify(lemmas), this.requestOptions)
  
  }

  //get surroundings
  public search(sourceLang: string, term: string, caseSensitive: boolean, diacriticsSensitive: boolean): Observable<JSON> {
    //console.log("term " + term);

    var args: string = "";
    if (!caseSensitive) {
      args += "&" + this.Case_insensitive;
    }
    if (!diacriticsSensitive) {
      args += "&" + this.Diacritic_insensitive
    }
    
    return this.http.get(this.SurroundingsURL + sourceLang + "/" + encodeURIComponent(term) + "?" + this.SurroundingsArguments + "&" + this.Recurse + args, this.requestOptions)
  }
}
